var map = {
	"./avatar-1.png": "./src/assets/images/users/avatar-1.png",
	"./avatar-10.png": "./src/assets/images/users/avatar-10.png",
	"./avatar-11.png": "./src/assets/images/users/avatar-11.png",
	"./avatar-12.png": "./src/assets/images/users/avatar-12.png",
	"./avatar-2.png": "./src/assets/images/users/avatar-2.png",
	"./avatar-3.png": "./src/assets/images/users/avatar-3.png",
	"./avatar-4.png": "./src/assets/images/users/avatar-4.png",
	"./avatar-5.png": "./src/assets/images/users/avatar-5.png",
	"./avatar-6.png": "./src/assets/images/users/avatar-6.png",
	"./avatar-7.png": "./src/assets/images/users/avatar-7.png",
	"./avatar-8.png": "./src/assets/images/users/avatar-8.png",
	"./avatar-9.png": "./src/assets/images/users/avatar-9.png",
	"./default_user.png": "./src/assets/images/users/default_user.png",
	"./img-user.png": "./src/assets/images/users/img-user.png",
	"./profile.png": "./src/assets/images/users/profile.png",
	"./super_user.jpg": "./src/assets/images/users/super_user.jpg",
	"./user-round.svg": "./src/assets/images/users/user-round.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/users sync recursive ^\\.\\/.*$";